import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReceiptUploadForm = _resolveComponent("ReceiptUploadForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      src: _ctx.landingPageConfig.image_path,
      alt: "landingPageImage",
      class: "sm:w-6/12 sm:px-1 my-0 mx-auto"
    }, null, 8, _hoisted_1),
    _createVNode(_component_ReceiptUploadForm, { chargeConfigUrlCode: _ctx.chargeConfigUrlCode }, null, 8, ["chargeConfigUrlCode"])
  ]))
}